import Spacing from 'components/Spacing';
import { Box, VStack } from 'components/Stack';
import Text from 'components/Text';
import { useResponsive } from 'hooks/useResponsive';
import { useTheme } from 'styled-components';

import Button from 'components/Button';
import RightArrow from 'components/icons/RightArrow';
import { useTranslation } from 'react-i18next';

const SectionD = ({ onClickBook }: { onClickBook?: () => void }) => {
  const theme = useTheme();
  const { isSmallScreen, isTabletScreen } = useResponsive();
  const { t } = useTranslation();

  return (
    <section className='sectionD'>
      <VStack className='container' $padding='0 1rem'>
        <Text
          color={theme.color.focus200}
          fontSize='1rem'
          fontWeight={700}
        >
          {t('시간마다커피그만')}
        </Text>
        <Box $width='100%' $alignItems='flex-start'>
          <Text
            $lineHeight='2'
            fontWeight={600}
            as='h2'
            color={theme.color.secondary1000}
            fontSize={isSmallScreen ? '1.6rem' : '2rem'}
          >
            {t('눈치보지말고편하게')}
          </Text>
        </Box>
        <Spacing />
        <Text color={theme.color.grey700}>
          {
            t('편하게설명')
          }
        </Text>
        <Spacing />
        <Button
          onClick={onClickBook}
          $bgColor={theme.color.secondaryGradient}
          $width='100%'
          $marginLeft='auto'
          $marginRight='auto'
          $padding='1rem 1.5rem'
          $alignItems='center'
          $justifyContent='space-between'
          $flexDirection='row'
        >
          <Text color={theme.color.grey100} fontSize='1rem' fontWeight={700}>
            {t('밤새공부하러가기')}
          </Text>
          <RightArrow size={16} color={theme.color.grey100} />
        </Button>
      </VStack>
    </section>
  );
};

export default SectionD;
